import React from 'react';
import MarketingNav from '../components/layout/MarketingNav';
import MarketingFooter from '../components/layout/MarketingFooter';
import Section from '../components/common/Section';
import SectionHeader from '../components/common/SectionHeader';
import Badge from '../components/ui/Badge';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen">
      <MarketingNav transparent={false} />

      <main>
        <Section background="light" padding="xl">
          <div className="max-w-3xl">
            <Badge variant="primary" className="mb-4">Privacy Policy</Badge>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6">Your privacy matters.</h1>
            <p className="text-lg md:text-xl text-text-muted">
              This policy explains how MHDF Momentum collects, uses, and protects your information.
            </p>
            <p className="mt-4 text-sm text-neutral-500">Last updated: February 4, 2026</p>
          </div>
        </Section>

        <Section background="white" padding="lg">
          <SectionHeader
            badge="Overview"
            title="What we collect and why"
            subtitle="We only collect information needed to deliver the program and keep it secure."
            alignment="left"
          />

          <div className="mt-8 space-y-6 text-sm text-neutral-700">
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Information we collect</h3>
              <ul className="mt-2 list-disc space-y-2 pl-5">
                <li>Account details (name, email, username, role).</li>
                <li>Program activity (daily completion, milestones, trends).</li>
                <li>Journal entries and reflections (encrypted at rest).</li>
                <li>Technical data (device, browser, IP for security).</li>
              </ul>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">How we use information</h3>
              <ul className="mt-2 list-disc space-y-2 pl-5">
                <li>Provide and improve the MHDF Momentum program.</li>
                <li>Secure accounts and prevent misuse.</li>
                <li>Enable clinician visibility with explicit client consent.</li>
              </ul>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Sharing & disclosure</h3>
              <p className="mt-2 text-neutral-600">
                We do not sell your data. We only share information with clinicians when you grant consent or when required by law.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Data security</h3>
              <p className="mt-2 text-neutral-600">
                Sensitive data is encrypted and protected with role-based access controls, monitoring, and secure infrastructure.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Your choices</h3>
              <p className="mt-2 text-neutral-600">
                You may request access, corrections, or deletion of your account subject to clinician assignment rules.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Contact</h3>
              <p className="mt-2 text-neutral-600">Email us at support@mhdfmomentum.com with any privacy questions.</p>
            </div>
          </div>
        </Section>
      </main>

      <MarketingFooter />
    </div>
  );
};

export default PrivacyPolicyPage;
